import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 19a4.875 4.875 0 1 0-4.833-4.875A4.84 4.84 0 0 0 16 19m0-8.25a3.375 3.375 0 1 1-3.375 3.375A3.38 3.38 0 0 1 16 10.75m2.344 9.75h-4.683A6.465 6.465 0 0 0 7 26.748 1.29 1.29 0 0 0 8.331 28h15.338A1.29 1.29 0 0 0 25 26.748a6.465 6.465 0 0 0-6.661-6.248Zm-9.83 6a4.99 4.99 0 0 1 5.109-4.5h4.716a4.936 4.936 0 0 1 5.114 4.5ZM25 11.5a3.75 3.75 0 1 0-3.75-3.75A3.75 3.75 0 0 0 25 11.5m0-6a2.25 2.25 0 1 1-2.25 2.25A2.25 2.25 0 0 1 25 5.5m-18 6a3.75 3.75 0 1 0-3.75-3.75A3.75 3.75 0 0 0 7 11.5m0-6a2.25 2.25 0 1 1-2.25 2.25A2.25 2.25 0 0 1 7 5.5M27.3 13h-3.05a3.5 3.5 0 0 0-1.522.349.75.75 0 1 0 .643 1.355 2.1 2.1 0 0 1 .879-.2h3.05a2.32 2.32 0 0 1 2.2 2.373v.623a.75.75 0 0 0 1.5 0v-.623A3.8 3.8 0 0 0 27.3 13M8.631 14.7a.75.75 0 0 0 .643-1.355A3.56 3.56 0 0 0 7.75 13H4.7A3.8 3.8 0 0 0 1 16.877v.623a.75.75 0 0 0 1.5 0v-.623A2.3 2.3 0 0 1 4.7 14.5h3.05a2.1 2.1 0 0 1 .881.2"
    }, null, -1)
  ])))
}
export default { render: render }